import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const PLACE_MESSAGE = gql`
    mutation($data: PlaceMessageInput!) {
        placeMessage(data: $data) {
            id
            folder {
                ...FolderCacheSafeFields
            }
            rank
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;
